import { Sidebar } from '@organisms/Sidebar';
import { TopNav } from '@organisms/TopNav';
import { Box as MuiBox } from '@mui/material';
import { useLayoutSettingContext } from '@contexts/LayoutSettingContext';
import {
  DefaultSidebarWidth,
  MiniSidebarWidth,
} from '@organisms/Sidebar/config-sidebar';
import { useResponsive } from '@hook/useResponsive';
import {
  TopNavDesktopHeight,
  TopNavMobileHeight,
} from '@organisms/TopNav/config-topnav';
import { CommonLayoutDefaultPadding } from './config';

export default function CommonLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isMobile } = useResponsive();
  const { isMini } = useLayoutSettingContext();

  return (
    <>
      {!isMobile && <Sidebar />}
      <MuiBox
        sx={{
          pl: isMini ? MiniSidebarWidth : DefaultSidebarWidth,
          ...(isMobile && {
            pl: 0,
          }),
        }}
      >
        <TopNav />

        <MuiBox
          component="main"
          sx={{
            p: `${CommonLayoutDefaultPadding}px`,
            pt: 0,
            ...(isMobile && {
              px: 2,
              pb: 8,
            }),
            height: `calc(100vh - ${
              isMobile ? TopNavMobileHeight : TopNavDesktopHeight
            })`,
            overflow: 'auto',
          }}
        >
          {children}
        </MuiBox>
      </MuiBox>
    </>
  );
}
